export default function getTextBasedOnType(t) {
  switch (t) {
    case 'in_person':
      return 'Presencial';
    case 'virtual':
      return 'Virtual';
    default:
      return 'Sin definir';
  }
}
